import {convertToScheduledSessions, EventListContainer, ChannelEventList} from "@mediaspace/event-platform/event-list";
import {ChannelSectionProps, WebcastEntry} from "@mediaspace/shared/types";
import {useMemo} from "react";
import {useConfig} from "@mediaspace/shared/data-kms-config";

export interface SessionsProps extends ChannelSectionProps<WebcastEntry[]>{
    hideFilterSessionsButton?: boolean
}

/**
 * Channel page sessions section - entries which contain scheduling data
 */
export function Sessions(props: SessionsProps) {
    const {content, hideFilterSessionsButton, categoryId} = props;

    const config = useConfig();
    const { dateFormats } = config.application;

    const scheduledSessions = useMemo(
        () => convertToScheduledSessions(content, dateFormats.longDateNoYear),
        [content, dateFormats.longDateNoYear]
    );

    return (
        <div className={"kms-ds-channel-page-section-sessions"}>
            <EventListContainer
                sessions={scheduledSessions}
                eventListComponent={<ChannelEventList />}
                hideFilterButton={hideFilterSessionsButton}
                categoryId={categoryId}
            />
        </div>
    );
}

export default Sessions;
